<script setup>
import { ref, watch } from "vue"
import { useVModels } from "@vueuse/core"
import { PencilSquareIcon } from '@heroicons/vue/24/solid'
import { PrimaryButton, Select, Text } from "@codinglabsau/ui"
import TargetSelector from "../Components/TargetSelector.vue"
import Modal from "@/Components/Inputs/BlockEditor/Extension/Components/Modal.vue"
import ToolbarButton from "@/Components/Inputs/BlockEditor/Extension/Components/ToolbarButton.vue"

const props = defineProps({
  href: {
    required: true,
  },
  alt: {
    required: true,
  },
  height: {
    required: true,
  },
  fit: {
    required: true,
  },
  target: {
    required: true,
  },
})

let showDialogue = ref(false)

const emits = defineEmits(['update:href', 'update:alt', 'update:height', 'update:fit', 'update:target'])

const {
  href: computedHref,
  alt: computedAlt,
  height: computedHeight,
  fit: computedFit,
  target: computedTarget,
} = useVModels(props, emits)

const heightControl = ref(props.height === 'full' ? 'full' : 'custom')
const heightControlOptions = [
  'full',
  'custom'
];
watch(() => heightControl.value, (value) => {
  if (value === 'full') {
    computedHeight.value = 'full'
  } else {
    computedHeight.value = 450
  }
})
</script>

<template>
  <ToolbarButton
    :icon="PencilSquareIcon"
    :label="__('Edit Image')"
    v-model="showDialogue"
  />
  <Modal v-model="showDialogue">
    <template #title>
      {{ __('Edit Image') }}
    </template>
    <div>
      <label for="href">{{ __('Link') }}</label>
      <Text
        v-model="computedHref"
        :description="__('Please provide a full url or a relative path e.g. \'/products/my-product-3255\'.')"
      />
    </div>
    <TargetSelector v-model="computedTarget"/>
    <div>
      <label for="alt"> {{ __('Alt') }}</label>
      <Text v-model="computedAlt"/>
    </div>
    <div>
      <label for="height"> {{ __('Height') }}</label>
      <div class="flex flex-col space-y-1">
        <label><input class="mr-2" type="radio" name="heightControl" v-model="heightControl" value="full">{{ __('Full') }}</label>
        <label><input class="mr-2" type="radio" name="heightControl" v-model="heightControl" value="custom">{{ __('Custom') }}</label>
      </div>
      <input v-if="heightControl === 'custom'" type="number" class="mt-2" step="1" min="0" max="999" required v-model="computedHeight">
    </div>
    <div>
      <label for="fit"> {{ __('Image fit') }}</label>
      <Select v-model="computedFit">
        <option value="none" selected>{{ __('None') }}</option>
        <option value="contain">{{ __('Contain') }}</option>
        <option value="cover">{{ __('Cover') }}</option>
        <option value="fill">{{ __('Fill') }}</option>
        <option value="scale-down">{{ __('Scale down') }}</option>
      </Select>
    </div>
    <PrimaryButton as="button" class="mt-2" type="button" @click.prevent="showDialogue = false">{{ __('Done') }}</PrimaryButton>
  </Modal>
</template>
